import { Link } from 'react-router-dom';
import { HeroDashboardMockup } from '@/components/HeroDashboardMockup';
import { Button } from '@/components/ui/button';
import { revealStyle, useScrollReveal } from '@/hooks/useScrollReveal';

/** Real Screen (spec 010 §3.4): one big real surface, three static callouts, an Example caption. */
const CALLOUTS = [
  { title: 'Upcoming session', body: 'Your next session, and how to join it, is the first thing you see.' },
  { title: 'Request a tutor', body: 'Ask for a tutor for the SAT or any other subject.' },
  { title: 'Feedback after every session', body: 'Your tutor writes up what you covered, so you know what to do next.' },
] as const;

export function TutoringRealScreen() {
  const { ref, isVisible } = useScrollReveal(0.1);
  return (
    <section aria-labelledby="tutoring-title">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 sm:px-6 lg:py-16">
        <h2 id="tutoring-title" className="max-w-[20ch] text-balance text-2xl font-semibold tracking-tight sm:text-3xl">
          And when you want a person
        </h2>

        <div ref={ref} style={revealStyle(isVisible)} className="mt-8 grid items-start gap-8 lg:grid-cols-[minmax(0,17rem)_minmax(0,1fr)] lg:gap-12">
          <ul className="grid gap-5 sm:grid-cols-3 lg:grid-cols-1" data-testid="tutoring-callouts">
            {CALLOUTS.map((c) => (
              <li key={c.title} className="border-l-2 border-primary/40 pl-4">
                <p className="font-semibold">{c.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{c.body}</p>
              </li>
            ))}
          </ul>

          <figure className="min-w-0">
            <div
              className="max-h-[34rem] overflow-hidden rounded-xl [mask-image:linear-gradient(to_bottom,black_82%,transparent)]"
              data-testid="tutoring-screen"
            >
              <HeroDashboardMockup />
            </div>
            <figcaption className="mt-3 text-sm text-muted-foreground">Example student dashboard.</figcaption>
          </figure>
        </div>

        <Button asChild variant="outline" className="mt-8 w-full sm:w-auto">
          <Link to="/how-it-works/students/">How tutoring works →</Link>
        </Button>
      </div>
    </section>
  );
}
